import { useSelector } from "react-redux";
import { LawyerReducer } from "../redux/lawyer/lawyerSlice";
import { lawyerSelectors } from "../redux/lawyer/selectors";

/** Whether the firm is on the Classic drafting allowlist. */
export const useLegacyDrafting = (): boolean =>
  useSelector(
    (s: LawyerReducer) => lawyerSelectors.selectLegacyDrafting(s) === true
  );
